<template>
  <div class="smd-panel message-multiple-attachments-item">
    <div class="flex-center--xy image-link-container">
      <img :src="thumbnailSrc" @load="loaded"/>
      <a :href="attachment.url" target="_blank">{{ displayFileName }}</a>
    </div>
  </div>
</template>

<script>
  import CommonMimeTypes from '@/reference/common-mime-types';
  import MimeTypeThumbnailMapping from '@/reference/mime-type-thumbnail-mapping';
  import MimeTypes from 'mime-types';

  export default {
    name: "message-multiple-attachments-item",
    props: {
      attachment: {type: Object, required: true}
    },
    computed: {
      displayFileName() {
        const fn = this.attachment.uploadid || '';

        if (fn.length > 20) {
          const pattern = /\.([0-9a-z]+)(?:[?#]|$)/i;
          const matches = fn.match(pattern);
          const ext = matches.length ? matches[0] : '';

          return `${fn.substr(0, 15)}...${ext}`;
        }

        return fn;
      },
      isImageMimeType() {
        const mt = this.mimeType;
        return mt === CommonMimeTypes.bmp || mt === CommonMimeTypes.jpg || mt === CommonMimeTypes.png;
      },
      mimeType() {

        return MimeTypes.lookup(this.attachment.uploadid);
      },
      thumbnailSrc() {
        if (this.isImageMimeType) {
          return this.attachment.url;
        }

        return MimeTypeThumbnailMapping[this.mimeType] || MimeTypeThumbnailMapping.default;
      }
    },
    methods: {
      loaded() {
        this.$emit('attachment-loaded');
      },
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .message-multiple-attachments-item {
    max-width: 140px;
    max-height: 180px;
    margin-bottom: space(s) !important;

    a {
      word-break: break-all;
    }

    &:not(:last-child) {
      @include responsive('max-width: 500px') {
        margin-right: 0;
      }
      margin-right: space(s);
    }

    img {
      max-height: 120px;
      max-width: 100px;
      height: 100%;
      width: 100%;
      margin-bottom: space(xs);
    }

    .image-link-container {
      height: 100%;
    }
  }
</style>